import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface TagPillProps {
  children: React.ReactNode;
  onRemove: () => void;
  removeLabel?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * The one shared removable-tag pill used everywhere a value can be
 * de-selected (countries, blueprints, domain TLDs, comparison chips, filter
 * chips). Solid accent fill, fully rounded, compact — replaces the three
 * divergent styles (bg-accent/10, bg-nav-active, bg-ghost-bg) that used to be
 * scattered across these components (bd deepcontext-fqlo).
 */
export const TagPill: React.FC<TagPillProps> = ({
  children,
  onRemove,
  removeLabel,
  disabled = false,
  className = '',
}) => (
  <span
    className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-accent text-white dark:text-surface ${className}`.trim()}
  >
    {children}
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onRemove();
      }}
      disabled={disabled}
      aria-label={removeLabel}
      className="opacity-70 hover:opacity-100 disabled:cursor-not-allowed disabled:opacity-40 transition-opacity"
    >
      <XMarkIcon className="h-3 w-3" />
    </button>
  </span>
);

export default TagPill;
